const messages = {
  title: "Consimțământuri de marketing",
  required: "Obligatoriu",
  answered: "✓ Răspuns",
  read: "Citit",
  notRead: "Necitit",
  alreadyAnswered: "Deja răspuns",
  requiredQuestionsMustBeAccepted:
    "Trebuie acceptate {count} întrebări obligatorii",
  pleaseAnswerQuestions: "Vă rugăm să răspundeți la următoarele întrebări:",
  iAccept: "Accept",
  scrollToUnlock: "Derulați până jos pentru deblocare",
  fieldRequired: "Acest câmp este obligatoriu",
  scrollToContinue: "↓ Derulați până jos pentru a continua",
  saving: "Se salvează...",
  saveConsents: "Salvați consimțămintele",
  allRequiredAccepted: "✓ Toate întrebările obligatorii acceptate",
  requiredConsentsCompleted:
    "{completed}/{total} consimțăminte obligatorii completate",
  selectConsentToView:
    "Selectați un consimțământ din listă pentru a vedea conținutul",
  readAllContentFirst: "Citiți mai întâi tot conținutul: {names}",
  acceptAllRequiredIn:
    "Acceptați toate întrebările obligatorii în: {names}",
  acceptAllBeforeSaving:
    "Acceptați toate întrebările obligatorii înainte de salvare.",
  failedToSave:
    "Consimțămintele nu au putut fi salvate. Încercați din nou.",
  errorSaving:
    "A apărut o eroare la salvarea consimțămintelor. Încercați din nou.",
  failedToLoad:
    "Consimțămintele nu au putut fi încărcate. Reîmprospătați pagina.",
  viewPdf: "Vizualizare PDF",
  requiredConsentTitle: "Consimțământ obligatoriu",
  acceptAndContinue: "Acceptă și continuă",
};

export default {
  messages,
};
